import React from "react";

interface InputAuthProps {
  name: string;
  text: string;
  type: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputAuth = ({ name, text, type, value, onChange }: InputAuthProps) => {
  return (
    <input
      className="font-inter border rounded-sm border-main-black px-4 h-11 text-sm bg-transparent"
      placeholder={text}
      onChange={onChange}
      value={value}
      type={type}
      name={name}
    />
  );
};

export default InputAuth;
